import { AllieSpinner, AllieText } from '../../../../components';
import { AlliePinMarked, AlliePinUnmarked, AllieEditPencilIcon } from '../../../../styling/icons';
import { ProcessVariableHeaderWrapper, StyledIconButton } from '../ProcessVariableCard.styles';
import { ProcessVariableCardProps } from '../ProcessVariableCard.types';
import { VariableTagsRow } from './VariableTagsRow';

interface VariableHeaderProps
  extends Omit<
    ProcessVariableCardProps,
    | 'value'
    | 'range'
    | 'status'
    | 'statusText'
    | 'machineName'
    | 'favoriteView'
    | 'textOutdated'
    | 'labelValues'
    | 'isMobile'
    | 'isMetricOnOff'
  > {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const VariableHeader = ({
  name,
  lastChangeAt,
  showFavButton,
  isFavorite,
  id,
  handleDeleteFavoriteVariable,
  handleAddFavoriteVariable,
  isLoading,
  setIsLoading,
  tags,
  onEditTags,
  editTagsAriaLabel,
}: VariableHeaderProps) => {
  const resetLoadingState = () => {
    setIsLoading(false);
  };

  return (
    <>
      <ProcessVariableHeaderWrapper>
        <div className="header-text">
          <AllieText color="neutral-70" type="button-normal">
            {name}
          </AllieText>
          <AllieText color="neutral-70" type="body3">
            {lastChangeAt}
          </AllieText>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
          {onEditTags && (
            <StyledIconButton
              size="xs"
              aria-label={editTagsAriaLabel}
              onClick={(e: any) => {
                e.stopPropagation();
                onEditTags();
              }}
            >
              <AllieEditPencilIcon />
            </StyledIconButton>
          )}
          {showFavButton && (
            <StyledIconButton
              size="xs"
              onClick={(e: any) => {
                e.stopPropagation();
                setIsLoading(true);

                if (isFavorite) {
                  handleDeleteFavoriteVariable(id, name, resetLoadingState);
                } else {
                  handleAddFavoriteVariable(id, name, resetLoadingState);
                }
              }}
            >
              {isLoading ? (
                <div>
                  <AllieSpinner name="crescent" />
                </div>
              ) : isFavorite ? (
                <AlliePinMarked />
              ) : (
                <AlliePinUnmarked />
              )}
            </StyledIconButton>
          )}
        </div>
      </ProcessVariableHeaderWrapper>
      {tags && tags.length > 0 && <VariableTagsRow tags={tags} />}
    </>
  );
};
